import withHandlers from 'recompose/withHandlers';
import withState from 'recompose/withState';
import withProps from 'recompose/withProps';
import compose from 'recompose/compose';
import ChairRentalModal from '../components/ChairRentalModal';
import chairRentalForm from './ChairRentalForm';
import confirmModal from '../../../../common/confirmModal';
import { t } from '../../../../../modules/infra/i18n';

// Store translation keys instead of calling t() at module level
const TAB_DETAILS_KEY = 'barber:chair_rental.modal.tab_details';

export default compose(
  chairRentalForm,
  withState('activeTab', 'setActiveTab', null),
  withProps(props => ({
    // Set initial activeTab value if it's null
    activeTab: props.activeTab || t(TAB_DETAILS_KEY),
  })),
  withHandlers({
    isTabWithForm: props => () => props.activeTab === t(TAB_DETAILS_KEY),
  }),
  withProps(ownProps => ({
    enabled: ownProps.isTabWithForm() ? ownProps.enabled : ownProps.chairRental.enabled,
  })),
  withHandlers({
    toggleEnabled: props => () => {
      if (!props.isTabWithForm()) {
        return false;
      }
      return props.change('enabled', !props.enabled);
    },
    closeModal: props => () => {
      if (!props.dirty) {
        return props.close();
      }

      return confirmModal({
        title: t('barber:chair_rental.unsaved_changes_title'),
        message: t('barber:chair_rental.unsaved_changes_message'),
        type: 'yesno',
        confirmButtonText: t('barber:common.yes'),
        negativeButtonText: t('barber:common.no'),
      },
        async () => {
          await props.submitForm();
          return props.close();
        },
        () => props.close()
      );
    },
  })
)(ChairRentalModal);
